export default function () {
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function eraseCookie(name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  // Check if body has id "cigars" with vanilla JS
  if (document.body.id === "cigars") {
    if (!getCookie("Cortes")) {
      // If cookie doesn't exist, set it
      setCookie("Cortes", "true", 1);
    }
  }

  if (document.body.id === "your-shopping-cart") {
    if (getCookie("Cortes")) {
      console.log("Cortes cookie exists");

      // if btn--checkout is clicked remove cookie and add note to cart
      const checkoutButton = document.querySelector(".btn--checkout");
      const cartLanding = document.getElementById("cartLanding");

      checkoutButton.addEventListener("click", () => {
        // eraseCookie("Cortes");
        // set value of carLanding to "cortes_landing"
        cartLanding.value = "cortes_landing";
      });
    }
  }
}
